import React, { useState, useEffect } from 'react';
import propTypes from 'prop-types';
import { Box, CircularProgress, TableCell, TextField, Tooltip, Typography } from '@mui/material';

import { renderSuccessMessage, renderErrorMessage } from '../../../lib/toastMessage';
import Logger from '../../../lib/Logger';

import AddCircleIcon from '@mui/icons-material/AddCircle';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import DeleteIcon from '@mui/icons-material/Delete';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { PaginationTable } from './paginationTable';
import { LoadingButton } from '@mui/lab';
import { axiosGetCall, axiosPostCall } from 'src/services/apisCall';
// import { axiosVBGetCall } from '../../../services/vbApiCall';

const BasicDatePicker = ({ value, onChange }) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        slotProps={{
          textField: { size: 'small' },
          actionBar: {
            actions: ['today', 'clear'],
          },
        }}
        sx={{ width: '270px', margin: '8px' }}
        value={value}
        onChange={(newValue) => onChange(newValue)}
      />
    </LocalizationProvider>
  );
};

BasicDatePicker.propTypes = {
  value: propTypes.number,
  onChange: propTypes.func.isRequired,
};

export const UserAmountPlanTable = ({ planWiseCredits = [], user = {}, forceLoad, loading: tableLoading }) => {
  const [rows, setRows] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [load, setLoad] = useState(false);

  const logger = new Logger('senderId');

  const handleFieldChange = (rowIndex, key, value) => {
    setRows((prevRows) => {
      const newRows = [...prevRows];
      newRows[rowIndex] = { ...newRows[rowIndex], [key]: value };
      return newRows;
    });
  };

  const isRowModified = (row) => {
    const originalRow = planWiseCredits.find(({ plan_id: planId }) => planId === row.plan_id);

    return (
      originalRow &&
      (String(originalRow.pulse ?? '') !== String(row.pulse ?? '') ||
        String(originalRow.pulse_rate ?? '') !== String(row.pulse_rate ?? ''))
    );
  };

  const handleUpdatePlan = async (plan, setLoading) => {
    setLoading(true);

    try {
      const { plan_id: planId, pulse, pulse_rate: pulseRate } = plan;
      const userId = user?.voiceInfo?.userId;

      if (planId && userId) {
        const payload = {
          assignTo: userId,
          planId,
          pulse,
          pulseRate,
          userType:"reseller" 
        };

        if (planId && userId) {
          const { message } = await axiosGetCall("VoicePlansAssignNUpdateUserPlan", payload);
          forceLoad();
          renderSuccessMessage(message);
        }
      }
    } catch (error) {
      logger.error('userAmountPlanTable.jsx, handleUpdatePlan', error);
      renderErrorMessage(error?.message);
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateCredits = async (plan, credit, setLoading, type) => {
    setLoading(true);

    try {
      if (credit === 0) {
        setLoading(false);
        return renderErrorMessage('Credit should be more than 0.');
      }
      const { plan_id: planId } = plan;
      const {
        voiceInfo: { userId },
      } = user;

      if (planId && userId && type) {
        const payload = { assignTo: userId, planId, credit, type };
        const { message } = await axiosPostCall('assignCreditToVoiceUser', payload);

        forceLoad();
        renderSuccessMessage(message);
      }
    } catch (error) {
      logger.error('userPlanTable.jsx ,handleUpdateCredits ,assignCreditToUser api', error);
      renderErrorMessage(error?.message);
    }

    setLoading(false);
  };

  const handleRemovePlan = async (plan, setLoading) => {
    setLoading(true);
    try {
      const { plan_id: planId } = plan;
      const {
        voiceInfo: { userId },
      } = user;

      if (planId && userId) {
        const payload = { actionUserId: userId, planId };
        const { message } = await axiosPostCall('voiceDeleteAmountPlanList', payload);
        forceLoad();
        renderSuccessMessage(message);
      }
    } catch (error) {
      logger.error('userPlanTable.jsx ,handleRemovePlan ,removeUserPlan api', error);
      renderErrorMessage(error?.message);
    }

    setLoading(false);
  };

  useEffect(() => {
    if (load) {
      setLoad(false);
    }
  }, [load]);

  useEffect(() => {
    const editablePlans = planWiseCredits.map((plan) => ({
      ...plan,
      pulse: plan.pulse ?? '',
      pulse_rate: plan.pulse_rate ?? '',
    }));
    setRows(editablePlans);
  }, [planWiseCredits]);

  const columns = [
    { id: 'plan_id', label: 'Plan ID', minWidth: 70, align: 'center' },
    { id: 'pulse', label: 'Pulse', minWidth: 125, align: 'center' },
    { id: 'pulse_rate', label: 'Pulse Rate', align: 'center' },

    {
      id: 'route',
      label: 'Route',
      minWidth: 100,
      align: 'center',
    },

    {
      id: 'actions',
      label: 'Action',
      minWidth: 200,
      align: 'center',
    },
  ];

  const ActionJsx = ({ id, align, value, row }) => {
    const [creditValue, setCreditValue] = useState(0);
    const [assignLoading, setAssignLoading] = useState(false);
    const [deductLoading, setDeductLoading] = useState(false);
    const [removePlanLoading, setRemovePlanLoading] = useState(false);
    const [updatePlanLoading, setUpdatePlanLoading] = useState(false);
    const rowModified = isRowModified(row);

    return (
      <TableCell
        key={id}
        align={align}
        sx={{
          color: 'grey.400',
          borderBottom: '0.5px dashed',
          borderColor: 'grey.700',
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          {/* <TextField id="outlined-basic" type='number' label="Credits" value={creditValue} onChange={(e) => setCreditValue(e.target.value)} size='small' variant="outlined" sx={{ width: "150px" }} /> */}

          {/* <Box >

                        <Tooltip title="Add Credit">

                            <LoadingButton
                                style={{
                                    width: '30px',
                                    minWidth: '30px'
                                }}
                                size="small"
                                color='success'
                                onClick={() => handleUpdateCredits(row, creditValue, setAssignLoading, "A")}
                                loading={assignLoading}
                                loadingIndicator={<CircularProgress style={{ color: '#22C55E' }} size={16} />}
                            >

                                <AddCircleIcon />
                            </LoadingButton>
                        </Tooltip >
                        <Tooltip title="Deduct Credit">

                            <LoadingButton
                                style={{
                                    width: '30px',
                                    minWidth: '30px'
                                }}
                                size="small" color='error' loading={deductLoading}
                                onClick={() => handleUpdateCredits(row, creditValue, setDeductLoading, "D")}
                                loadingIndicator={<CircularProgress style={{ color: '#FF5630' }} size={16} />}
                            >
                                <RemoveCircleIcon />
                            </LoadingButton>
                        </Tooltip>
                    </Box> */}
          {rowModified ? (
            <Tooltip title="Update Plan">
              <LoadingButton
              variant="outlined" size='small' color='primary'
                loading={updatePlanLoading}
                onClick={() => handleUpdatePlan(row, setUpdatePlanLoading)}
              >
                Update
              </LoadingButton>
            </Tooltip>
          ) : (
            <Tooltip title="Remove Plan">
              <LoadingButton
                style={{
                  width: '30px',
                  minWidth: '30px',
                }}
                size="small"
                sx={{ color: 'red' }}
                loading={removePlanLoading}
                loadingIndicator={<CircularProgress style={{ color: 'red' }} size={16} />}
                onClick={() => handleRemovePlan(row, setRemovePlanLoading)}
              >
                <DeleteIcon />
              </LoadingButton>
            </Tooltip>
          )}
        </Box>
      </TableCell>
    );
  };

  return (
    <Box>
      <Typography id="modal-modal-title" variant="h6" component="h2" sx={{ mb: '-20px' }}>
        Currrent Assign Plan
      </Typography>
      <PaginationTable
        page={page}
        ActionJsx={ActionJsx}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        loading={tableLoading}
        rows={rows}
        columns={columns}
        maxHeight={680}
        mapKey="plan_id"
        onRowFieldChange={handleFieldChange}
        notEditablePulse={true}
      />
    </Box>
  );
};

UserAmountPlanTable.propTypes = {
  planWiseCredits: propTypes.arrayOf(propTypes.object),
  user: propTypes.object,
  forceLoad: propTypes.func.isRequired,
  loading: propTypes.bool,
};
